import { Slider as SliderMantine } from '@mantine/core'
import styled from 'styled-components'

export const Slider = styled(SliderMantine)`
  .mantine-Slider-track::before {
    background-color: ${({ theme }) => theme.cor27} !important;
  }
`
